import { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import injectSaga from '@utils/injectSaga';
import injectReducer from '@utils/injectReducer';
import Text, { TEXT_COLOR, TEXT_SIZE } from '@components/Text';
import DSPHandler from '@shared/DSPHandler';
import { V2_MONITOR_REGISTRY } from '@shared/Resources/Monitor/v2Monitors/registry';
import V2ExerciseRuntime from './components/V2ExerciseRuntime';
import VideoMonitor from '@shared/VideoMonitor';
// import ProductionDurationCounter from './components/ProductionDurationCounter';
import {
  ERROR_TYPES,
  LOCATION_TYPES,
  PROGRESS_TYPE,
  MONITOR_HANDLER_STATUS,
  STIMULUS_TYPE,
  STIMULUS_DIVISION_TYPE,
  PATTERN_TYPES,
  MONITOR_TYPES,
} from '@shared/Resources/Monitor/types';
import { openPopUp } from '@containers/App/containers/PopUp/actions';
import VideoMonitorService from '@services/videoMonitorService';
import { stopVideoRecording } from '@shared/VideoMonitor/actions';
import { getSecondsFromFormatTime } from '@utils/timeHelpers';
import { SubHeader } from '@containers/User/containers/CourseRouter/containers/MonitorHandler/components/SubHeader';
import SectionLoading from '@components/SectionLoading';
import { Tooltip } from '@components/Tooltip';
import { HiddenVideoPlaceholder } from '@shared/VideoMonitor/styles';
import CTAButton from '@components/CTAButton';
import {
  defineErrorsList,
  filterForStaticMonitorErrors,
} from '@containers/User/containers/CourseRouter/containers/MonitorHandler/helpers';
import RepetitionProgress from './components/RepetitionProgress';
import { MonitorFeedbackTooltip } from './components/MonitorFeedbackTooltip/index.tsx';
import StimuliModule from './containers/StimuliModule';
import {
  MirrorWrapper,
  MonitorOverlay,
  MonitorWrapper,
  VideoPauseIcon,
  MirrorWithVideoWrapper,
  StyledVideo,
  LargeMirrorWrapper,
  VideoWrapper,
  VideoOverlay,
  VideoControlButton,
  InhaleInstructionWrapper,
  MainWrapper,
  MonitorButton,
  MonitorButtonsWrapper,
  RecordedAudioPlayer,
  ProgressWrapper, Wrapper,
} from './styles';
import {
  saveActivityProduction,
  setMonitorProduction,
  setMonitorSubProductionInProgressFlag,
  insertNewRepetitionIntoRepetitionResults,
  setErrorsInProductionResults,
  setMonitorErrors,
  setRepetitionInSequenceIndex,
  setMonitorActiveFlag,
  setExercisePausedFlag,
  setMicrophoneActiveFlag,
  resetExerciseData,
  advanceToNextSequence,
  advanceToNextSyllable,
  disconnectFromMirrorSession,
  resetRepetitionResults,
  setListOneSecondAmountsOfSyllables,
  setIntervalExercise,
} from './actions';
import saga from './saga';
import reducer from './reducer';
import { checkErrorsAndGetNames } from '../../../../helpers/monitorErrors';
import POPUP_TYPES from '../../../../../App/containers/PopUp/types';
import { tryingToExitExerciseAction } from '../Practice/actions';
import { FIELD_FOR_CHECK, TIMER_INTERVAL } from './consts';

export class MonitorHandler extends Component {
  constructor(props) {
    super(props);
    this.stream = null;
    this.mediaRecorder = null;
    this.audioChunks = [];
    this.messageEventListener = null;
    this.intervalExercise = null;
    this.videoRef = createRef();
    this.isVideoStarted = createRef();
    this.isVideoStarted.current = false;
    this.state = {
      isLoading: false,
      localArchiveId: null,
      inhaling: false,
      syllableCount: 1,
      hideStartButton: false,
      productionCount: 0,
      repetitionPosition: 0,
      errorRepetitionPosition: [],
      recordedAudioUrl: null,
    };
  }

  componentDidMount() {
    const { currentExercise, updateExerciseProgressTime } = this.props;
    if (!_.isEmpty(currentExercise)) {
      this.resetExerciseData();
      if (currentExercise.monitor.progress.type === PROGRESS_TYPE.TIMER) {
        updateExerciseProgressTime(getSecondsFromFormatTime(currentExercise.monitor.progress.value));
      }
    }

    this.messageEventListener = (e) => {
      if (
        e.data === 'archiveIdWasCreated'
        && !this.props.monitorActive
        && !this.props.microphoneStarted
        && !this.props.exercisePaused
      ) {
        this.setState({ localArchiveId: VideoMonitorService.archiveId });
      }

      if (e.data === 'archiveWasStopped') {
        this.setState({ localArchiveId: null });
      }
    };

    window.addEventListener('message', this.messageEventListener);
  }

  checkProps = (field) => {
    const { currentExercise } = this.props;
    if (!currentExercise
      || !currentExercise.monitor
      || !currentExercise.monitor.progress
      || !currentExercise.monitor.progress[field]
    ) {
      return false;
    }
    return true;
  };

  componentDidUpdate(prevProps) {
    const {
      currentExercise,
      dispatchTryingExitExercise,
      exerciseProgressTime,
      updateExerciseProgressTime,
      startNoiseCalibration,
      exercisePaused,
      exerciseInProgress,
      currentSequenceIndex,
      syllableCount,
      dispatchSetMonitorActiveFlag,
      dispatchSetMicrophoneActiveFlag,
      isLesson,
    } = this.props;
    const progressValue = _.get(currentExercise, 'monitor.progress.value');
    const monitor = currentExercise?.monitor?.monitor;
    const sequenceProgressed = currentSequenceIndex !== prevProps.currentSequenceIndex;
    const exerciseStarted = exerciseInProgress && !prevProps.exerciseInProgress;
    if (
      (sequenceProgressed || exerciseStarted)
      && currentSequenceIndex >= progressValue
      && this.hasRuntimeMonitor(monitor)
      && exerciseInProgress
    ) {
      this.endExercise();
    }

    if (currentExercise?.monitor?.pattern?.type === PATTERN_TYPES.ONE_SECOND
      && syllableCount !== this.state.syllableCount) {
      this.setState({ syllableCount });
    }

    if (!_.isEqual(currentExercise, prevProps.currentExercise)) {
      this.resetExerciseData();
    }

    if (this.exitConditionHandler(prevProps)) {
      dispatchTryingExitExercise(false);
    }

    if (this.checkProps(FIELD_FOR_CHECK.VALUE)
      && prevProps.currentExercise.monitor.progress.value !== currentExercise.monitor.progress.value
    ) {
      if (currentExercise.monitor.progress.type === PROGRESS_TYPE.TIMER) {
        updateExerciseProgressTime(getSecondsFromFormatTime(currentExercise.monitor.progress.value));
      }
    }

    if (this.checkProps(FIELD_FOR_CHECK.TYPE)
      && currentExercise.monitor.progress.type === PROGRESS_TYPE.TIMER
      && exerciseProgressTime === 0
      && this.intervalExercise
    ) {
      this.endExercise();
      clearInterval(this.intervalExercise);
      this.intervalExercise = null;
    }

    if (!_.isEqual(startNoiseCalibration, prevProps.startNoiseCalibration)) {
      if (startNoiseCalibration && exerciseInProgress) {
        this.pauseExercise(false);
      }
    }

    this.syncAudioRecordingWithPauseState(prevProps.exercisePaused, exercisePaused, exerciseInProgress);

    if (this.state.localArchiveId && !this.props.monitorActive && this.props.exerciseInProgress && !this.props.exercisePaused && !isLesson) {
      dispatchSetMonitorActiveFlag(true);
      dispatchSetMicrophoneActiveFlag(true);
      this.setState({ isLoading: false });
      this.startAudioRecording();
    }
  }

  componentWillUnmount() {
    this.stopAudioRecording();
    if (this.stream) {
      this.stream.getTracks().forEach((track) => {
        track.stop();
      });
    }
    if (this.state.recordedAudioUrl) {
      URL.revokeObjectURL(this.state.recordedAudioUrl);
    }
    this.stopMediaStream();
    const {
      dispatchDisconnectFromMirrorSession,
    } = this.props;

    const archiveId = this.state.localArchiveId
      ? this.state.localArchiveId
      : VideoMonitorService.archiveId;

    dispatchDisconnectFromMirrorSession(archiveId);
    if (this.messageEventListener) {
      window.removeEventListener('message', this.messageEventListener);
      this.messageEventListener = null;
    }

    if (this.intervalExercise) {
      clearInterval(this.intervalExercise);
    }
  }

  exitConditionHandler = (prevProps) => {
    const {
      exerciseInProgress,
      popupDisplayed,
      exercisePaused,
      tryingToExit,
    } = this.props;

    const isTryingToExitFirstTime = tryingToExit && tryingToExit !== prevProps.tryingToExit;
    const isPopUpDisplayedFirstTime = popupDisplayed && popupDisplayed !== prevProps.popupDisplayed;
    const isExerciseNotPaused = exerciseInProgress && !exercisePaused;

    return (
      isExerciseNotPaused
      && (isPopUpDisplayedFirstTime || isTryingToExitFirstTime)
    );
  };

  stopMediaStream = () => {
    this.stopAudioRecording();
    if (this.stream) {
      this.stream.getTracks().forEach((track) => {
        track.stop();
      });
    }
  };

  startAudioRecording = () => {
    if (!this.props.currentExercise?.monitor.monitor?.playback?.on) {
      return;
    }
    if (!this.stream || typeof MediaRecorder === 'undefined') {
      return;
    }
    if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
      return;
    }

    const audioTracks = this.stream.getAudioTracks();
    if (!audioTracks.length) {
      return;
    }

    this.audioChunks = [];
    const audioStream = new MediaStream(audioTracks);
    const recorder = new MediaRecorder(audioStream);
    this.mediaRecorder = recorder;

    recorder.ondataavailable = (event) => {
      if (event.data && event.data.size > 0) {
        this.audioChunks.push(event.data);
      }
    };

    recorder.onstop = () => {
      if (!this.audioChunks.length) {
        return;
      }
      if (this.state.recordedAudioUrl) {
        URL.revokeObjectURL(this.state.recordedAudioUrl);
      }

      const mimeType = recorder.mimeType || 'audio/webm';
      const audioBlob = new Blob(this.audioChunks, { type: mimeType });
      this.setState({ recordedAudioUrl: URL.createObjectURL(audioBlob) });
    };

    recorder.start();
  };

  stopAudioRecording = () => {
    if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
      this.mediaRecorder.stop();
    }
  };

  syncAudioRecordingWithPauseState = (prevExercisePaused, exercisePaused, exerciseInProgress) => {
    if (exercisePaused === prevExercisePaused) {
      return;
    }

    if (exercisePaused) {
      this.stopAudioRecording();
      return;
    }

    if (exerciseInProgress) {
      this.startAudioRecording();
    }
  };

  onExerciseEnd = () => {
    const { endExercise } = this.props;
    // exercise ended - stop recording and end exercise
    endExercise();
  };

  setInhaling(value) {
    this.setState({ inhaling: value });
  }

  shouldEndSequence() {
    const {
      repetitionsInSequence,
      repetitionInSequenceIndex,
      stimuli,
      currentSequenceIndex,
      currentExercise,
    } = this.props;
    const division = currentExercise?.monitor?.stimulus?.config?.division;
    const stimuliType = currentExercise?.monitor?.stimulus?.type;
    const stimuliLength = stimuli.length;
    // check if this is the last repitition but not the last sequence
    return ((stimuliType === STIMULUS_TYPE.WORDS
      && (division === STIMULUS_DIVISION_TYPE.UNDIVIDED || (division === STIMULUS_DIVISION_TYPE.DIVIDED
        && repetitionInSequenceIndex < repetitionsInSequence + 1)))
      || stimuliType === STIMULUS_TYPE.SYLLABLES)
      && repetitionInSequenceIndex + 1 === repetitionsInSequence && ((stimuliLength && currentSequenceIndex < stimuliLength - 1));
  }

  isEndOfStimuliWord() {
    const {
      stimuli,
      currentSyllableIndex,
      currentExercise,
    } = this.props;
    const baseStimulus = currentExercise.monitor.pattern.type === PATTERN_TYPES.ONE_SECOND ? [...new Set(stimuli)] : stimuli;
    const notTheLastSyllable = currentSyllableIndex < baseStimulus.length - 1;
    const isLastSyllableInWord = notTheLastSyllable && baseStimulus[currentSyllableIndex].text !== baseStimulus[currentSyllableIndex + 1].text;
    const isLastSyllable = currentSyllableIndex === baseStimulus.length - 1;
    return (isLastSyllableInWord || isLastSyllable);
  }

  isUndividedWords() {
    const {
      currentExercise,
    } = this.props;
    const division = currentExercise?.monitor?.stimulus?.config?.division;
    const stimuliType = currentExercise?.monitor?.stimulus?.type;
    return stimuliType === STIMULUS_TYPE.WORDS && division === STIMULUS_DIVISION_TYPE.UNDIVIDED;
  }

  isLastSequence() {
    const {
      repetitionsInSequence,
      repetitionInSequenceIndex,
      stimuli,
      currentSequenceIndex,
      currentExercise,
    } = this.props;
    const stimuliType = currentExercise?.monitor?.stimulus?.type;
    const stimuliLength = stimuli.length;
    // there is only one sequence or this is the last sequence and last repitition
    return ((stimuliType !== STIMULUS_TYPE.WORDS
      && stimuliType !== STIMULUS_TYPE.SYLLABLES) || (repetitionInSequenceIndex === repetitionsInSequence
        && ((stimuliLength && currentSequenceIndex === stimuliLength - 1) || !stimuliLength)));
  }

  updateExerciseProgression = (type, payload) => {
    const {
      dispatchSetMonitorSubProductionInProgressFlag,
      dispatchInsertNewRepetitionIntoRepetitionResults,
      dispatchSetErrorsInProductionResults,
      dispatchSetMonitorErrors,
      repetitionInSequenceIndex,
      dispatchSetRepetitionInSequenceIndex,
      dispatchSetMonitorProduction,
      dispatchAdvanceToNextSequence,
      dispatchResetRepetitionResults,
      currentExercise,
      currentSequenceIndex,
      repetitionsInSequence,
    } = this.props;
    const { monitor } = currentExercise;
    const { pattern } = monitor;

    switch (type) {
      case MONITOR_HANDLER_STATUS.PRODUCTION_START:
        dispatchSetMonitorSubProductionInProgressFlag(true);
        if (!this.state.inhaling) {
          dispatchInsertNewRepetitionIntoRepetitionResults();
        }
        break;
      case MONITOR_HANDLER_STATUS.MAIN_MONITOR_RESULTS: {
        const { productionErrors } = payload.monitorResult;
        const parsedErrors = this.parsePayloadErrors(productionErrors);
        const hasErrorsToDisplay = _.find(
          parsedErrors,
          (error) => error.location !== 'inhalation' && error.displayed === true,
        );
        this.setState((prevState) => {
          const stateToChange = { productionCount: prevState.productionCount + 1 };
          if (repetitionsInSequence > 1) {
            let { repetitionPosition } = prevState;
            if (repetitionPosition === (repetitionsInSequence - 1)) {
              repetitionPosition = 0;
            } else {
              repetitionPosition += 1;
            }
            if (hasErrorsToDisplay) {
              const errorRepetitionPositions = this.state.errorRepetitionPosition;
              const errorPosition = repetitionPosition === 0 ? repetitionsInSequence - 1 : repetitionPosition - 1;
              // const errorPosition = repetitionPosition - 1;
              errorRepetitionPositions.push(errorPosition);
              stateToChange.errorRepetitionPosition = errorRepetitionPositions;
            } else if (repetitionPosition === 1) {
              stateToChange.errorRepetitionPosition = [];
            }

            stateToChange.repetitionPosition = repetitionPosition;
          }
          return stateToChange;
        });

        const stimuliType = currentExercise?.monitor?.stimulus?.type;

        if (repetitionsInSequence <= 1) {
          dispatchAdvanceToNextSequence();
        } else if (this.state.repetitionPosition >= (repetitionsInSequence - 1)) {
          dispatchAdvanceToNextSequence();
        }

        if (hasErrorsToDisplay) {
          dispatchSetErrorsInProductionResults();
        }
        if (!this.isLastSequence()) {
          // finished repetition in sequence
          dispatchSetRepetitionInSequenceIndex(repetitionInSequenceIndex + 1);
        }
        this.setInhaling(true); // finishes exhaling

        const divisionType = this.props.stimulus?.config?.division;
        const repetition = _.get(currentExercise, 'monitor.progress.repetition');
        if (stimuliType !== STIMULUS_TYPE.SYLLABLES && (stimuliType !== STIMULUS_TYPE.WORDS && divisionType === STIMULUS_DIVISION_TYPE.DIVIDED) && !repetition.on) {
          pattern.type !== PATTERN_TYPES.ONE_SECOND && dispatchAdvanceToNextSequence();
        }
        dispatchSetMonitorSubProductionInProgressFlag(false);
        dispatchSetMonitorErrors(parsedErrors);
        if (pattern.type === PATTERN_TYPES.ONE_SECOND && currentSequenceIndex !== (currentExercise.monitor.progress.value - 1)) {
          if (!this.props.isLesson) {
            const { productionErrors } = payload.monitorResult;
            const parsedErrors = this.parsePayloadErrors(productionErrors);
            this.saveProduction(parsedErrors, payload);
          }
        }
        if (pattern.type === PATTERN_TYPES.ONE_SECOND && currentSequenceIndex === (currentExercise.monitor.progress.value - 1)) {
          if (!this.props.isLesson) {
            const { productionErrors } = payload.monitorResult;

            const parsedErrors = this.parsePayloadErrors(productionErrors);
            this.saveProduction(parsedErrors, payload);
          }
        }
        break;
      }
      case MONITOR_HANDLER_STATUS.SINGLE_MONITOR_PRODUCTION_END: {
        if (!this.props.exerciseInProgress && !this.props.isLesson) {
          this.startExercise();
        }
        const { productionErrors } = payload.monitorResult;
        const { updatedProduction } = payload;
        const parsedErrors = this.parsePayloadErrors(productionErrors);
        if (pattern.type !== PATTERN_TYPES.ONE_SECOND || (pattern.type === PATTERN_TYPES.ONE_SECOND && this.props.isLesson)) {
          this.saveProduction(parsedErrors, payload);
        }
        this.setInhaling(false); // finishes inhaling
        dispatchSetMonitorSubProductionInProgressFlag(false);
        dispatchSetMonitorErrors(parsedErrors);
        dispatchSetMonitorProduction(updatedProduction);
        if (this.isUndividedWords()) {
          dispatchResetRepetitionResults();
        }
        break;
      }
      default:
        break;
    }
  };

  saveProduction = (parsedErrors, { monitorResult }) => {
    const {
      dispatchSaveActivityProduction,
      activityContext,
      stimuli,
      currentSequenceIndex,
    } = this.props;
    const {
      monitorType,
      patternType,
      speed,
      inhalationDuration,
      dspSignal,
      startTS,
      endTS,
    } = monitorResult;

    const stimulus = stimuli[currentSequenceIndex];
    const productionErrors = parsedErrors;

    let stimuliDisplayed = {};

    if (stimulus) {
      stimuliDisplayed = {
        id: stimulus.stimuliId,
        wordIndex: stimulus.wordIndex,
        syllableIndex: stimulus.syllableIndex,
      };
    } else {
      stimuliDisplayed = {
        id: '12345',
        wordIndex: 0,
        syllableIndex: 0,
      };
    }

    const payload = {
      activityContext,
      monitorType,
      patternType,
      speed,
      inhalationDuration: !inhalationDuration ? 1 : inhalationDuration,
      dspSignal,
      startTS: startTS / 1000,
      endTS: endTS / 1000,
      productionErrors,
      stimuliDisplayed,
    };
    dispatchSaveActivityProduction(payload);
  };

  parsePayloadErrors(payloadErrors) {
    if (!payloadErrors) return [];
    const volumeControlBeginningErrors = [
      ERROR_TYPES.sharpRiseBeginning,
      ERROR_TYPES.volumeRiseBeginning,
      ERROR_TYPES.shapeBeginning,
    ];
    const volumeControlEndErrors = [
      ERROR_TYPES.shapeEnd,
      ERROR_TYPES.volumeFallEnd,
      ERROR_TYPES.sharpFallEnd,
    ];
    let types = _.clone(this.props.currentExercise.monitor.errors.types);
    const hasVolumeControlBeginning = _.find(types, {
      type: ERROR_TYPES.volumeControlBeginning,
    });
    const hasVolumeControlEnd = _.find(types, {
      type: ERROR_TYPES.volumeControlEnd,
    });
    const volumeControlBeginning = {
      type: ERROR_TYPES.volumeControlBeginning,
      location: 'beginning',
      exists: false,
      displayed: false,
    };
    const volumeControlEnd = {
      type: ERROR_TYPES.volumeControlEnd,
      location: 'end',
      exists: false,
      displayed: false,
    };

    if (hasVolumeControlBeginning) {
      _.remove(types, { type: ERROR_TYPES.volumeControlBeginning });
      types = _.concat(
        types,
        volumeControlBeginningErrors.map((error) => ({ type: error })),
      );
    }
    if (hasVolumeControlEnd) {
      _.remove(types, { type: ERROR_TYPES.volumeControlEnd });
      types = _.concat(
        types,
        volumeControlEndErrors.map((error) => ({ type: error })),
      );
    }

    let parsedErrors = payloadErrors.map((error) => {
      const isErrorChecked = Boolean(_.find(types, { type: error.type }));
      const displayed = Boolean(error.exists && isErrorChecked);
      if (volumeControlBeginningErrors.includes(error.type)) {
        if (displayed) {
          volumeControlBeginning.displayed = true;
          volumeControlBeginning.exists = true;
        }
      }
      if (volumeControlEndErrors.includes(error.type)) {
        if (displayed) {
          volumeControlEnd.displayed = true;
          volumeControlEnd.exists = true;
        }
      }
      return {
        ...error,
        displayed,
      };
    });
    let nonGentleOnset = _.remove(parsedErrors, {
      type: ERROR_TYPES.nonGentleOnset,
    });
    let nonGentleOffset = _.remove(parsedErrors, {
      type: ERROR_TYPES.nonGentleOffset,
    });
    nonGentleOnset = nonGentleOnset.length > 0 ? nonGentleOnset[0] : null;
    nonGentleOffset = nonGentleOffset.length > 0 ? nonGentleOffset[0] : null;
    if (
      nonGentleOnset
      && nonGentleOnset.displayed
      && volumeControlBeginning.displayed
    ) {
      volumeControlBeginning.displayed = false;
    }
    if (
      nonGentleOffset
      && nonGentleOffset.displayed
      && volumeControlEnd.displayed
    ) {
      nonGentleOffset.displayed = false;
    }
    let displayedProductionErrors = _.remove(parsedErrors, {
      location: LOCATION_TYPES.PRODUCTION,
      displayed: true,
    });
    if (displayedProductionErrors.length > 1) {
      displayedProductionErrors = displayedProductionErrors.map((error) => {
        if (
          [
            ERROR_TYPES.tooShortProduction,
            ERROR_TYPES.tooLongProduction,
          ].includes(error.type)
        ) {
          return {
            ...error,
            displayed: false,
          };
        }
        return error;
      });
    }
    parsedErrors = _.concat(
      parsedErrors,
      volumeControlBeginning,
      volumeControlEnd,
      nonGentleOnset,
      nonGentleOffset,
      displayedProductionErrors,
    );
    return _.compact(parsedErrors);
  }

  startExercise = () => {
    const {
      isLesson, startExercise, monitorActive, microphoneStarted, dispatchSetMonitorActiveFlag, dispatchSetMicrophoneActiveFlag,
    } = this.props;
    this.setState({ isLoading: true });
    this.increaseExerciseProgressTime();
    if (!isLesson) {
      startExercise();
    }
    if (isLesson && !monitorActive && !microphoneStarted) {
      dispatchSetMonitorActiveFlag(true);
      dispatchSetMicrophoneActiveFlag(true);
      this.setState({ isLoading: false });
      this.startAudioRecording();
    }
  };

  endExercise = () => {
    const {
      dispatchSetMonitorActiveFlag,
      dispatchSetMicrophoneActiveFlag,
      endExercise,
    } = this.props;

    dispatchSetMonitorActiveFlag(false);
    dispatchSetMicrophoneActiveFlag(false);
    endExercise();
  };

  pauseExercise = (defaultPause = true) => {
    if (!this.props.exerciseInProgress) return;
    defaultPause && this.setState({ isLoading: true });
    if (this.checkProps(FIELD_FOR_CHECK.TYPE)
      && this.props.currentExercise.monitor.progress.type === PROGRESS_TYPE.TIMER
    ) {
      clearInterval(this.intervalExercise);
    }

    const {
      dispatchSetMonitorActiveFlag,
      dispatchSetMicrophoneActiveFlag,
      dispatchSetExercisePausedFlag,
    } = this.props;

    this.stopAudioRecording();
    dispatchSetMonitorActiveFlag(false);
    dispatchSetMicrophoneActiveFlag(false);
    dispatchSetExercisePausedFlag(true);

    if (VideoMonitorService.archiveId) {
      this.setState({ localArchiveId: VideoMonitorService.archiveId });
    }
    if (this.videoRef.current) this.videoRef.current.pause();
  };

  resumeExercise = () => {
    const {
      dispatchSetMonitorActiveFlag,
      dispatchSetMicrophoneActiveFlag,
      dispatchSetExercisePausedFlag,
      monitorActive,
      microphoneStarted,
    } = this.props;

    this.increaseExerciseProgressTime();

    if (!monitorActive && !microphoneStarted) {
      dispatchSetMonitorActiveFlag(true);
      dispatchSetMicrophoneActiveFlag(true);
      dispatchSetExercisePausedFlag(false);
    }
  };

  resetExerciseData = () => {
    const { dispatchResetExerciseData, currentExercise } = this.props;
    const repetition = _.get(currentExercise, 'monitor.progress.repetition');
    const repetitionsInSequence = repetition && repetition.on ? repetition.count : 1;
    dispatchResetExerciseData(repetitionsInSequence);
  };

  increaseExerciseProgressTime = () => {
    if (this.checkProps(FIELD_FOR_CHECK.TYPE)
      && this.props.currentExercise.monitor.progress.type === PROGRESS_TYPE.TIMER
    ) {
      this.intervalExercise = setInterval(() => {
        this.props.updateExerciseProgressTime(this.props.exerciseProgressTime - 1);
        this.props.dispatchSetIntervalExercise(this.intervalExercise);
      }, TIMER_INTERVAL);
    }
  };

  startWithMediaDevicesPermissions = async () => {
    this.setState({ hideStartButton: true });
    const { dispatchOpenPopUp, exercisePaused, isLesson } = this.props;
    if (exercisePaused) {
      this.resumeExercise();
      this.setState({ hideStartButton: false });
      return;
    }

    try {
      const videoStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: isLesson
          ? undefined
          : {
              width: { ideal: 640 },
              height: { ideal: 480 },
              frameRate: { ideal: 30, max: 30 },
            },
      });
      this.stream = videoStream;
      this.startExercise();
      this.setState({ hideStartButton: false });
    } catch (err) {
      dispatchOpenPopUp(POPUP_TYPES.MEDIA_DEVICES_PERMISSIONS);
    }
  };

  handleVideoControlButtonClick = () => {
    const {
      startExercise,
      exercisePaused,
      exerciseInProgress,
      dispatchSetExercisePausedFlag,
    } = this.props;
    if (exerciseInProgress) {
      if (exercisePaused) {
        // resume video - recording is not paused
        dispatchSetExercisePausedFlag(false);
        this.videoRef.current.play();
      } else {
        // pause video - recording is not paused
        dispatchSetExercisePausedFlag(true);
        this.videoRef.current.pause();
      }
    } else {
      // start video + exercise recording
      startExercise();
      this.videoRef.current.play();
      this.isVideoStarted.current = true;
    }
  };

  isProductionBySyllableCount = (pattern, stimulus) => {
    // relevant only for one second monitor with divided sentences or words
    if (pattern.type === PATTERN_TYPES.ONE_SECOND) {
      return (stimulus?.type === STIMULUS_TYPE.SENTENCES && stimulus?.config?.division === STIMULUS_DIVISION_TYPE.DIVIDED_TO_WORDS_SYLLABLES)
        || (stimulus?.type === STIMULUS_TYPE.WORDS);
    }
    return false;
  };

  renderMonitors() {
    const {
      microphoneStarted,
      currentExercise,
      activityContext,
      stimuli,
      repetitionsInSequence,
    } = this.props;
    const { stimulus } = currentExercise?.monitor;
    const { monitor } = currentExercise;
    const { pattern } = monitor;
    const listAmountsOfSyllables = [];
    if (stimuli && stimuli.length) {
      const division = currentExercise?.monitor?.stimulus?.config?.division;
      const isOneSecond = pattern.type === PATTERN_TYPES.ONE_SECOND;
      const isWords = stimulus.type === STIMULUS_TYPE.WORDS;
      const isSentences = stimulus.type === STIMULUS_TYPE.SENTENCES;
      const isDividedSentences = isSentences && division !== STIMULUS_DIVISION_TYPE.UNDIVIDED;
      if (isOneSecond && (isWords || isDividedSentences)) {
        const amountOfSeq = monitor.progress.type === PROGRESS_TYPE.TIMER ? stimuli.length : monitor.progress.value;
        const amountToCount = amountOfSeq * repetitionsInSequence;
        for (let i = 0; i < amountToCount; i += repetitionsInSequence) {
          if (stimuli[i]) {
            if (stimulus.type === STIMULUS_TYPE.WORDS) {
              listAmountsOfSyllables.push(stimuli[i].length);
            } else {
              const currentSeq = stimuli[i].find((stimuli) => stimuli.current);
              const wordsArray = currentSeq.text.trim().split(/\s+/);
              listAmountsOfSyllables.push(wordsArray.length);
            }
          }
        }
      }
    }

    const props = {
      monitor: monitor.monitor,
      pattern,
      updateMonitorResults: this.updateExerciseProgression,
      microphoneStarted,
      activityContext,
      listAmountsOfSyllables,
      amountOfSeq: monitor.progress.value,
    };

    if (this.isProductionBySyllableCount(pattern, stimulus)) {
      if (this.state.syllableCount < 1) return null;
      props.pattern.productionDuration = this.state.syllableCount;
    }
    const withMirror = monitor.monitor.mirror.on;
    if (!this.hasRuntimeMonitor(monitor.monitor)) return null;
    return (
      <Wrapper>
        {this.renderStaticMonitorsFeedback()}
        <MonitorWrapper withMirror={withMirror}>
          <DSPHandler {...props} />
          {this.renderMonitorsOverlay()}
          {this.renderMonitorsFeedbacks(listAmountsOfSyllables)}
          {this.renderInhaleInstruction()}
        </MonitorWrapper>
      </Wrapper>
    );
  }

  renderMonitorsOverlay() {
    const {
      exerciseInProgress,
      monitorActive,
      isLesson,
      exercisePaused,
      currentExercise,
    } = this.props;
    const { isLoading, recordedAudioUrl } = this.state;
    const monitor = currentExercise?.monitor;
    const playbackEnabled = !!monitor?.monitor?.playback?.on;
    const canPlayRecording = playbackEnabled && exercisePaused && Boolean(recordedAudioUrl);

    let handleMonitorButton = exerciseInProgress ? this.resumeExercise : this.startWithMediaDevicesPermissions;
    if (isLesson) handleMonitorButton = monitorActive ? this.pauseExercise : this.startWithMediaDevicesPermissions;

    return (
      <MonitorOverlay monitorActive={monitorActive}>
        {isLoading ? <SectionLoading />
          : (
            <MonitorButtonsWrapper>
              <MonitorButton
                isHide={this.state.hideStartButton}
                onClick={handleMonitorButton}
              >
                {this.props.t(`Actions.Instance.${exercisePaused ? 'continue' : 'start'}`)}
              </MonitorButton>
              {canPlayRecording && (
                  <Tooltip content={this.props.t('UI.playbackOption')} placement="top" hasArrow>
                    <RecordedAudioPlayer
                      controls
                      controlsList="nodownload noplaybackrate"
                      disableRemotePlayback
                      src={recordedAudioUrl}
                    >
                      Playback is not supported in your browser.
                    </RecordedAudioPlayer>
                  </Tooltip>
              )}
            </MonitorButtonsWrapper>
          )}

      </MonitorOverlay>
    );
  }

  // This function renders some of the toast errors that should be positioned absolutely according to the screen
  renderStaticMonitorsFeedback() {
    const {
      monitorErrors,
      exerciseInProgress,
      productionDuration,
      currentExercise: { monitor },
    } = this.props;
    if (!exerciseInProgress) return null;
    if (this.state.inhaling) {
      const currentMonitorType = monitor?.pattern?.type;
      const errorsToRender = defineErrorsList(currentMonitorType, monitorErrors);

      return (
        <>
          {errorsToRender.map((error) => (
            <MonitorFeedbackTooltip
              location={error.location}
              error={error.name}
              key={`${error.location}-${error.type}`}
              duration={productionDuration}

            />
          ))}
        </>
      );
    }
  }

  renderMonitorsFeedbacks(listAmountsOfSyllables) {
    const {
      monitorErrors,
      exerciseInProgress,
      production,
      productionDuration,
      currentExercise: { monitor },
      syllableCount,
      currentSequenceIndex,
    } = this.props;
    const currentMonitorType = monitor?.pattern?.type;

    if (!exerciseInProgress) return null;
    if (this.state.inhaling) {
      // display production errors
      let displayedErrors = monitorErrors.filter(
        (error) => error.location !== 'inhalation' && error.displayed,
      );

      // some cases where toast error should be positioned as absolute were moved to the separate function renderStaticMonitorsFeedback()
      // this filter function is used to find them and remove from array
      displayedErrors = filterForStaticMonitorErrors(currentMonitorType, displayedErrors);

      displayedErrors = checkErrorsAndGetNames(displayedErrors);

      const errorsToRender = defineErrorsList(currentMonitorType, monitorErrors);
      if (!errorsToRender.length && !displayedErrors.length) {
        return (
          <MonitorFeedbackTooltip
            location={LOCATION_TYPES.RIGHT_SIDE_MIDDLE}
            error="great"
          />
        );
      }

      return (
        <>
          {displayedErrors.map((error) => (
            <MonitorFeedbackTooltip
              location={error.location}
              error={error.name}
              key={`${error.location}-${error.type}`}
              duration={listAmountsOfSyllables?.[currentSequenceIndex] ?? productionDuration}
            />
          ))}
        </>
      );
    }
    // display inhalation errors
    if (production === 0) return null;
    let displayedErrors = monitorErrors.filter(
      (error) => error.location === 'inhalation' && error.displayed,
    );
    displayedErrors = checkErrorsAndGetNames(displayedErrors);
    if (displayedErrors.length === 0) {
      return (
        <MonitorFeedbackTooltip
          location="inhalation"
          error="great"
        />
      );
    }
    return (
      <>
        {displayedErrors.map((error) => (
          <MonitorFeedbackTooltip
            location={error.location}
            error={error.name}
            key={`${error.location}-${error.type}`}
          />
        ))}
      </>
    );
  }

  renderInhaleInstruction = () => (this.state.inhaling ? (
    <InhaleInstructionWrapper>
      <Text
        textColor={TEXT_COLOR.DARK}
        size={TEXT_SIZE.T2}
        textTransform="uppercase"
        weight="bold"
      >
        {this.props.t('Common.UI.inhale')}
      </Text>
    </InhaleInstructionWrapper>
  ) : null);

  handleClickInLesson = () => {
    const {
      startExercise,
      exercisePaused,
      dispatchSetExercisePausedFlag,
    } = this.props;
    // Start video first time
    if (!this.isVideoStarted.current) {
      startExercise();
      this.videoRef.current.play();
      this.isVideoStarted.current = true;
    }
    // Continue play video after pause
    if (exercisePaused) {
      dispatchSetExercisePausedFlag(false);
      this.videoRef.current.play();
    }
  };

  renderVideoControlButton = () => {
    const {
      exercisePaused,
      exerciseInProgress,
      isLesson,
    } = this.props;
    if (isLesson) {
      if (exerciseInProgress
          && this.isVideoStarted.current
          && !exercisePaused
      ) {
        return (
          <VideoControlButton
            onlyIcon
            onClick={this.handleVideoControlButtonClick}
          >
            <VideoPauseIcon />
          </VideoControlButton>
        );
      }
      return (
        <VideoControlButton onClick={this.handleClickInLesson}>
          {this.props.t(`Actions.Instance.${exercisePaused ? 'continue' : 'start'}`)}
        </VideoControlButton>
      );
    }
    if (exerciseInProgress && !exercisePaused) {
      return (
        <VideoControlButton
          onlyIcon
          onClick={this.handleVideoControlButtonClick}
        >
          <VideoPauseIcon />
        </VideoControlButton>
      );
    }
    return (
      <VideoControlButton onClick={this.handleVideoControlButtonClick}>
        {this.props.t(`Actions.Instance.${exercisePaused ? 'continue' : 'start'}`)}
      </VideoControlButton>
    );
  };

  renderMirror = () => {
    const {
      currentExercise: {
        monitor: { stimulus, monitor },
      },
      exercisePaused,
      exerciseInProgress,
      isLesson,
    } = this.props;
    const displayMirror = monitor.mirror.on;
    const withVideo = monitor.video.on;
    const videoUrl = withVideo ? monitor.video.url : '';

    const noMonitor = !this.hasRuntimeMonitor(monitor);
    const noExtraMonitor = !withVideo && !displayMirror && !monitor.inhalation.on && !monitor.speedometer.on;
    const showContinueButton = isLesson && noMonitor && noExtraMonitor;

    const props = {
      displayMirror,
      isLesson,
    };

    if (!props.displayMirror && !props.isLesson && !withVideo) {
      return (
        <HiddenVideoPlaceholder shrinkedHeight id="publisher" />
      );
    }

    if (showContinueButton) {
      return <CTAButton onClick={this.onExerciseEnd}>{this.props.t('Actions.Instance.continue')}</CTAButton>
    }

    if (withVideo) {
      return (
        <MirrorWithVideoWrapper>
          <VideoWrapper>
            <StyledVideo
              src={videoUrl}
              onEnded={this.onExerciseEnd}
              ref={this.videoRef}
            />
            <VideoOverlay
              exercisePaused={exercisePaused}
              exerciseInProgress={exerciseInProgress}
              isVideoStarted={this.isVideoStarted.current}
            >
              {this.renderVideoControlButton()}
            </VideoOverlay>
          </VideoWrapper>
          <LargeMirrorWrapper>
            <VideoMonitor {...props} />
          </LargeMirrorWrapper>
        </MirrorWithVideoWrapper>
      );
    }
    return (
      <MirrorWrapper displayMirror={displayMirror}>
        <VideoMonitor {...props} />
      </MirrorWrapper>
    );
  };

  hasRuntimeMonitor = (monitor) => monitor.type !== MONITOR_TYPES.NONE;

  renderStimuli() {
    const {
      currentSequenceIndex,
      currentExercise,
      dispatchSetListOneSecondAmountsOfSyllables,
    } = this.props;
    const { stimulus, progress } = currentExercise.monitor;
    const stimuliModuleProps = {
      currentSequence: currentSequenceIndex,
      ...stimulus,
      progress,
      currentExercise,
      setListOneSecondAmountsOfSyllables: dispatchSetListOneSecondAmountsOfSyllables,
      productionCount: this.state.productionCount,
    };
    return <StimuliModule {...stimuliModuleProps} />;
  }

  renderProgress() {
    const {
      subProductionInProgress,
      repetitionsResults,
      repetitionsInSequence,
    } = this.props;
    const {
      repetitionPosition, inhaling, errorRepetitionPosition, productionCount,
    } = this.state;
    if (!repetitionsInSequence || repetitionsInSequence <= 1) {
      return null;
    }
    // TODO: add handling for exercises without inhale monitor (controlled speech and farther)
    return (
      <ProgressWrapper>
        <RepetitionProgress
          productions={repetitionsResults}
          repetitions={repetitionsInSequence}
          repetitionPosition={repetitionPosition}
          disableCurrentIndicator={inhaling || !subProductionInProgress}
          errorRepetitionPosition={errorRepetitionPosition}
          productionCount={productionCount}
        />
      </ProgressWrapper>
    );
  }

  render() {
    const {
      currentExercise,
      currentSequenceIndex,
      exerciseInProgress,
    } = this.props;
    const {
      monitor: {
        monitor,
      },
    } = currentExercise;
    const hasRuntimeMonitor = this.hasRuntimeMonitor(monitor);
    const v2Definition = V2_MONITOR_REGISTRY[monitor.type];
    const { stimulus } = currentExercise.monitor;

    return (
      <MainWrapper>
        <SubHeader
          exerciseProgressTime={this.props.exerciseProgressTime}
          currentSequenceIndex={currentSequenceIndex}
          currentExercise={currentExercise}
          pauseExerciseHandler={this.pauseExercise}
        />
        {this.renderMirror()}
        {hasRuntimeMonitor && (v2Definition
          ? (
            <V2ExerciseRuntime
              activityContext={this.props.activityContext}
              currentExercise={currentExercise}
              currentSequenceIndex={currentSequenceIndex}
              definition={v2Definition}
              exerciseInProgress={exerciseInProgress}
              exercisePaused={this.props.exercisePaused}
              microphoneStarted={this.props.microphoneStarted}
              monitorActive={this.props.monitorActive}
              onAdvanceRepetition={this.props.dispatchSetRepetitionInSequenceIndex}
              onAdvanceSequence={this.props.dispatchAdvanceToNextSequence}
              onPause={() => this.pauseExercise(false)}
              onSaveProduction={(payload) => (
                this.props.dispatchSaveActivityProduction(payload, true)
              )}
              overlay={this.renderMonitorsOverlay()}
              repetitionInSequenceIndex={this.props.repetitionInSequenceIndex}
              repetitionsInSequence={this.props.repetitionsInSequence}
              stimuli={this.props.stimuli}
              stimuliEntityId={this.props.stimuliEntityId}
            />
          )
          : (
            <>
              {stimulus?.type && (stimulus.type === STIMULUS_TYPE.PICTURES || stimulus.type === STIMULUS_TYPE.SPEECH_TOPICS)
                ? (
                  <>
                    {this.renderStimuli()}
                    {this.renderMonitors()}
                  </>
                )
                : (
                  <>
                    {this.renderMonitors()}
                    {this.renderStimuli()}
                  </>
                )}
              {this.renderProgress()}
            </>
          ))}
        <HiddenVideoPlaceholder id="screenRecordPublisher" />
      </MainWrapper>
    );
  }
}

MonitorHandler.propTypes = {
  currentExercise: PropTypes.object,
  exerciseInProgress: PropTypes.bool,
  popupDisplayed: PropTypes.bool,
  activityContext: PropTypes.object,
  dispatchSaveActivityProduction: PropTypes.func,
  stimuli: PropTypes.array,
  stimuliEntityId: PropTypes.string,
  endExercise: PropTypes.func,
  startExercise: PropTypes.func,
  dispatchSetMonitorProduction: PropTypes.func,
  dispatchSetMonitorSubProductionInProgressFlag: PropTypes.func,
  dispatchInsertNewRepetitionIntoRepetitionResults: PropTypes.func,
  dispatchSetErrorsInProductionResults: PropTypes.func,
  dispatchSetMonitorErrors: PropTypes.func,
  dispatchSetRepetitionInSequenceIndex: PropTypes.func,
  dispatchSetMonitorActiveFlag: PropTypes.func,
  dispatchSetMicrophoneActiveFlag: PropTypes.func,
  dispatchSetExercisePausedFlag: PropTypes.func,
  dispatchResetExerciseData: PropTypes.func,
  dispatchAdvanceToNextSequence: PropTypes.func,
  dispatchOpenPopUp: PropTypes.func,
  dispatchDisconnectFromMirrorSession: PropTypes.func,
  production: PropTypes.number,
  monitorActive: PropTypes.bool,
  microphoneStarted: PropTypes.bool,
  exercisePaused: PropTypes.bool,
  subProductionInProgress: PropTypes.bool,
  monitorErrors: PropTypes.array,
  currentSequenceIndex: PropTypes.number,
  repetitionInSequenceIndex: PropTypes.number,
  repetitionsInSequence: PropTypes.number,
  repetitionsResults: PropTypes.array,
  isLesson: PropTypes.bool,
  productionDuration: PropTypes.number,
  connectedToMirror: PropTypes.bool,
  tryingToExit: PropTypes.bool,
  currentSyllableIndex: PropTypes.number,
  syllableCount: PropTypes.number,
};

export const mapStateToProps = (state) => {
  const popUpState = state.getIn(['popUp']).toJS();
  const popupDisplayed = popUpState.showing;
  const videoMirrorState = state.getIn(['videoMirror']);
  const connectedToMirror = _.get(videoMirrorState, 'connectedToMirror', false);
  const stimuliModule = state.getIn(['stimuliModule']);
  const {
    stimuli,
    stimuliEntityId,
    syllableCount,
  } = stimuliModule ? stimuliModule.toJS() : {};
  const { activityContext } = state.getIn(['course']).toJS();
  const currentPractice = state.getIn(['currentPractice']).toJS();
  const { tryingToExit } = currentPractice;
  const {
    production,
    monitorActive,
    microphoneStarted,
    exercisePaused,
    subProductionInProgress,
    monitorErrors,
    currentSequenceIndex,
    repetitionInSequenceIndex,
    repetitionsInSequence,
    repetitionsResults,
    startNoiseCalibration,
    currentSyllableIndex,
    listOneSecondAmountsOfSyllables,
  } = state.getIn(['monitorHandler']).toJS();
  return {
    popupDisplayed,
    activityContext,
    stimuli,
    stimuliEntityId,
    syllableCount,
    production,
    monitorActive,
    microphoneStarted,
    exercisePaused,
    subProductionInProgress,
    monitorErrors,
    currentSequenceIndex,
    repetitionInSequenceIndex,
    repetitionsInSequence,
    repetitionsResults,
    connectedToMirror,
    tryingToExit,
    startNoiseCalibration,
    currentSyllableIndex,
    listOneSecondAmountsOfSyllables,
  };
};

export function mapDispatchToProps(dispatch) {
  return {
    dispatchSaveActivityProduction: (payload, waitForCompletion = false) => {
      if (!waitForCompletion) {
        return dispatch(saveActivityProduction(payload));
      }
      return new Promise((resolve, reject) => {
        dispatch(saveActivityProduction(payload, { resolve, reject }));
      });
    },
    dispatchSetMonitorProduction: (production) => dispatch(setMonitorProduction(production)),
    dispatchSetMonitorSubProductionInProgressFlag: (value) => dispatch(setMonitorSubProductionInProgressFlag(value)),
    dispatchInsertNewRepetitionIntoRepetitionResults: () => dispatch(insertNewRepetitionIntoRepetitionResults()),
    dispatchSetErrorsInProductionResults: () => dispatch(setErrorsInProductionResults()),
    dispatchSetMonitorErrors: (errors) => dispatch(setMonitorErrors(errors)),
    dispatchSetRepetitionInSequenceIndex: (index) => dispatch(setRepetitionInSequenceIndex(index)),
    dispatchSetMonitorActiveFlag: (value) => dispatch(setMonitorActiveFlag(value)),
    dispatchSetMicrophoneActiveFlag: (value) => dispatch(setMicrophoneActiveFlag(value)),
    dispatchSetExercisePausedFlag: (value) => dispatch(setExercisePausedFlag(value)),
    dispatchResetExerciseData: (repetitionsInSequence) => dispatch(resetExerciseData(repetitionsInSequence)),
    dispatchAdvanceToNextSequence: () => dispatch(advanceToNextSequence()),
    dispatchAdvanceToNextSyllable: (currentSyllableIndex) => dispatch(advanceToNextSyllable(currentSyllableIndex)),
    dispatchResetRepetitionResults: () => dispatch(resetRepetitionResults()),
    dispatchOpenPopUp: (type) => dispatch(openPopUp(type)),
    dispatchDisconnectFromMirrorSession: (archiveId) => dispatch(disconnectFromMirrorSession(archiveId)),
    dispatchStopVideoRecording: () => dispatch(stopVideoRecording()),
    dispatchTryingExitExercise: (tryingToExit) => dispatch(tryingToExitExerciseAction(tryingToExit)),
    dispatchSetListOneSecondAmountsOfSyllables: (list) => dispatch(setListOneSecondAmountsOfSyllables(list)),
    dispatchSetIntervalExercise: (interval) => dispatch(setIntervalExercise(interval)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({ key: 'monitorHandler', reducer });
const withSaga = injectSaga({ key: 'monitorHandler', saga });

export default compose(
  withSaga,
  withReducer,
  withConnect,
  withTranslation(),
)(MonitorHandler);
